import { useCallback, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import SideBar from '../componants/sidebar/SideBar';
import { useStateContext } from '../Contexts/ContextProvider';
import Navbar from '../componants/navbar/Navbar';
import Notification from '../assets/Notification';
import { Fade } from 'react-awesome-reveal';
import Footer from '../componants/Footer';
import { WorkspacePage } from '../componants/Workspace';

function AdminLayout() {
  const { isAuthenticated, isInitializing, notifications } = useStateContext();
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const closeMobileNav = useCallback(() => setIsMobileNavOpen(false), []);
  const toggleMobileNav = useCallback(() => setIsMobileNavOpen((open) => !open), []);

  if (isInitializing) return <div className="p-5 text-center">Verifying your account...</div>;
  if (!isAuthenticated) return <Navigate to="/" replace />;

  return (
    <div className="app-shell">
      <SideBar
        isExpanded={isSidebarExpanded}
        isMobileOpen={isMobileNavOpen}
        onExpandedChange={setIsSidebarExpanded}
        onMobileClose={closeMobileNav}
      />

      <main className="app-main">
        <Navbar
          isMobileNavOpen={isMobileNavOpen}
          onMobileNavToggle={toggleMobileNav}
        />

        <WorkspacePage className="app-page">
          <Outlet />
        </WorkspacePage>

        <Footer />

        <div className="notification-stack">
          {notifications.map((notifi) => (
            <div key={notifi.id}>
              <Fade triggerOnce>
                <Notification notification={notifi} />
              </Fade>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}

export default AdminLayout;
